import React from "react";

import HomeRoute from "../../features/home/HomeRoute";

const Home = () => (
  <div className="home-page full-bleed">
    <HomeRoute />
  </div>
);

export default Home;
